module.exports = __webpack_public_path__ + "images/calendar.4b7fc2dd.png";